





















































import { Component, Vue } from "vue-property-decorator";
import ApiTableItem from "@/components/integrations/ApiTableItem.vue";
import {
  Application as IApplication,
  ApplicationsList as IApplicationsList,
  ErrorResponse as IErrorResponse,
  ValidationErrorResponse as IValidationErrorResponse
} from "@/api/models";
import { getCurrentUserId } from "@/plugins/roles";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import DeleteMaterialModal from "@/components/form/DeleteMaterialModal.vue";

@Component({ components: { ApiTableItem, DeleteMaterialModal } })
export default class ApiList extends Vue {
  appsList: Array<IApplication> = [];
  offset: number = 0;
  limit: number = 30;
  itemCount: number | undefined = 0;
  gettingResult: boolean = false;
  appIdForDelete!: string | undefined;

  data() {
    return {
      appIdForDelete: undefined
    };
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get currentUserID() {
    return getCurrentUserId();
  }

  cancelRemove() {
    this.appIdForDelete = undefined;
  }

  deleteItem() {
    if (this.appIdForDelete)
      api.ApplicationApi._delete(this.appIdForDelete).then(() => {
        this.appsList = [];
        this.getAPPS();
        this.appIdForDelete = undefined;
        this.$bvModal.hide("modal-1");
        this.offset = 0;
      });
  }

  getRemItem(id: string) {
    this.appIdForDelete = id;
  }

  getAPPS(offset: number = 0) {
    this.gettingResult = true;
    api.ApplicationApi.list(this.currentUserID, offset, this.limit)
      .then((res: { data: IApplicationsList }) => {
        this.itemCount = res.data.count;
        res.data.items.forEach(el => {
          this.appsList.push(el);
        });
      })
      .finally(() => {
        this.gettingResult = false;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  showMore() {
    this.offset += this.limit;
    this.getAPPS(this.offset);
  }

  mounted() {
    this.getAPPS();
  }
}
